module.exports = __webpack_public_path__ + "img/person_pc.84494ff1.png";